import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AppelsService } from '../../service/appels.service';
import { Certificat } from 'src/app/model/certificat';
import {
  catchError,
  filter,
  finalize,
  findIndex,
  forkJoin,
  map,
  of,
  tap,
} from 'rxjs';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { NewParcourCertificate } from 'src/app/model/NewParcourCertificate';
import { HorsParcourCertificate } from 'src/app/model/hors-parcours-certificate.model';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
//import { Router } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NewTestQualification } from 'src/app/model/NewTestQualification.model';
import * as XLSX from 'xlsx';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { MatPaginator } from '@angular/material/paginator';
import { PaginatedResponse } from 'src/app/interfaces/paginateResponse.interface';
import { co } from '@fullcalendar/core/internal-common';
import { UnifiedCertificateDTO } from 'src/app/model/dto/UnifiedCertificateDTO';
import {
  ApplicationSimplifyService,
  IntervenantResponse,
} from 'src/app/modules/application-simplify/application-simplify.service';
import { de, el } from 'date-fns/locale';
import { MentoratService } from 'src/app/modules/mentorat/services/mentorat.service';
import { HttpErrorResponse } from '@angular/common/http';

interface CategorieCertificat {
  id: number;
  categoryName: string;
}
interface CohortesParcours {
  id: number;
  cohorteName: string;
}

interface NewParcour {
  id: number;
  name: string;
  shortname: string;
  fullname: string;
  displayname: string;
  startdate: number;
  enddate: number;
  urlCertificat: string;
  plateforme: string;
  description: string;
  status: string;
  updatedAt: string;
  cohorte?: string;
  externalId?: number;
  certificatType?: string;
  category?: CategorieCertificat;
}

// Interface pour les certificats hors parcours (si nécessaire, ajustez selon votre structure réelle)
interface HorsParcoursCertificat {
  id: number;
  externalId: string;
  name: string;
  shortname: string;
  fullname: string;
  displayname: string;
  startdate: number;
  enddate: number;
  urlCertificat: string;
  plateforme: string;
  description: string;
  urlImage: string;
  offTrackCohort?: string;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
  status?: string;
  certificatCategory?: any;
  applicationOffTrack?: any;
}

interface Webinaire {
  id: number;
  name: string;
  fullname?: string;
  shortname?: string;
  startdate: number;
  enddate: number;
  plateforme?: string;
  description?: string;
  accessLink?: string;
  status?: string;
  certificatType?: string;
}

@Component({
  selector: 'app-sigui-certificats',
  templateUrl: './sigui-certificats.component.html',
  styleUrls: ['./sigui-certificats.component.css'],
})
export class SiguiCertificatsComponent implements OnInit {
  [x: string]: any;

  showSpinner = false;

  testForm!: FormGroup;
  nameCtrl!: FormControl;
  openDateCtrl!: FormControl;
  closeDateCtrl!: FormControl;
  accessLinkCtrl!: FormControl;
  isPublicCtrl!: FormControl;
  createdByCtrl!: FormControl;
  createdAtCtrl!: FormControl;
  updatedAtCtrl!: FormControl;
  idCertificatCtrl!: FormControl;
  isSucces: boolean = false;
  isUpdate: boolean = false;
  serverError: boolean = false;
  inValid: boolean = false;

  testsByCertificate: NewTestQualification[] = [];
  deleteError: boolean = false;
  testFormTitle: string = 'Ajouter un test au certificat';
  addButton: boolean = true;
  updateButton: boolean = false;
  selectedTest!: NewTestQualification;
  showDeleteModal: boolean = false;
  addUser: boolean = false;
  fileIsValid: boolean = false;
  editCertificatMode: boolean = false;
  cohortesList: CohortesParcours[] = [];
  selectedCohortCtrl!: FormControl;
  fileSize: number = 0;
  fileName!: string;
  file: File | null = null; // Variable to store file
  maxFileSize: number = 5120000;
  fileContent: string[] | undefined;
  fileContentXls!: any[];
  succes = false;
  error = false;
  excelData!: any[];
  updateSucces: boolean = false;
  updateError: boolean = false;
  updateMessage: string = '';
  updateWebinarError: boolean = false;
  updateWebinarErrorText: string = '';
  copiedCertificatId: any = null;
  certificatCodes: { code: string; label: string }[] = [];
  listRole = [
    { name: 'Modérateur', value: 'MODERATOR' },
    { name: 'Animateur', value: 'PANELISTE' },
  ];

  // Civilités proposées (mêmes valeurs que le modèle Excel d'import)
  civilityOptions: { value: string; label: string }[] = [
    { value: 'M.', label: 'Monsieur (M.)' },
    { value: 'Mme', label: 'Madame (Mme)' },
  ];

  webinaireTypeOptions: { value: string; label: string }[] = [];

  constructor(
    private certificatService: AppelsService,
    private mentoratService: MentoratService,
    private spinnerService: SpinnerServiceService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private applicationSimplifyService: ApplicationSimplifyService,
  ) {
    // this.spinnerService.spinner$.subscribe((data: boolean) => {
    //   setTimeout(() => {
    //     this.showSpinner = data ? data : false;
    //   });
    // });
  }

  certificatsParcours: any[] = [];
  certificatsHorsParcours: any[] = [];
  webinaires: any[] = [];
  moderatorsByWebinar: any[] = [];
  certifiacatsMentorat: any[] = [];

  // Propriétés de pagination
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  currentPageParcoursCertificate = 0;
  pageSizeParcoursCertificate = 10;
  totalElementsParcoursCertificate = 0;
  paginatedResponseParcoursCertificate: PaginatedResponse<NewParcourCertificate> | null =
    null;

  currentPageHorsParcoursCertificate = 0;
  pageSizeHorsParcoursCertificate = 10;
  totalElementsHorsParcoursCertificate = 0;
  paginatedResponseHorsParcoursCertificate: PaginatedResponse<HorsParcourCertificate> | null =
    null;

  currentPageWebinaire = 0;
  pageSizeWebinaire = 10;
  totalElementsWebinaire = 0;
  paginatedResponseWebinaire: PaginatedResponse<any> | null = null;

  currentPageMentoratCertificate = 0;
  pageSizeMentoratCertificate = 10;
  totalElementsMentoratCertificate = 0;
  paginatedResponseMentoratCertificate: PaginatedResponse<any> | null = null;

  currentPageAll = 0;
  pageSizeAll = 10;
  totalElementsAll = 0;
  paginatedResponseAll: PaginatedResponse<UnifiedCertificateDTO> | null = null;

  unifiedCertificates: UnifiedCertificateDTO[] = [];
  pageSizeOptions: number[] = [10, 20, 30, 50, 100];

  filterType: string = 'all';

  webinaireSearchTerm: string = '';
  private webinaireSearchTimeout: any = null;

  formattedStartDat!: string;
  formattedEndDat!: string;
  edit: boolean = false;
  dateActuel!: any;
  showDetails = false;
  showCertificatDetailsModal = false;
  showConfirmUpdateModal: boolean = false;

  showTestFormModal = false;
  selectedCertificat!: any;
  selectedHorsParcoursCertificat!: HorsParcourCertificate;
  invalidCategorie!: boolean;

  mutliNotif!: boolean;
  saveError!: boolean;
  multiError!: boolean;
  noFile!: boolean;
  formattedStartDate: string = '';
  formattedEndDate: string = '';

  isDropdownOpen: boolean = false;

  addMentor: boolean = false;
  mentorForm!: FormGroup;
  moderatorSuccess: boolean = false;
  moderatorError: boolean = false;
  showConfirmModeratorModal = false;
  pendingModeratorDto: any = null;

  categorys: CategorieCertificat[] = [
    { id: 1, categoryName: 'Analyse des Données' },
    { id: 2, categoryName: 'Business' },
    { id: 3, categoryName: 'Cloud' },
    { id: 4, categoryName: 'Data Manegement' },
    { id: 5, categoryName: 'Développement mobile et web' },
    { id: 6, categoryName: 'Gestion de projet' },
    { id: 7, categoryName: 'Marketing Vente' },
    { id: 8, categoryName: 'Sécurité' },
    { id: 9, categoryName: 'Sopport et Operations' },
  ];
  isAdmin: boolean = false;
  profil: any;
  user: any | null;
  role!: any;
  isBeninGestionnaire!: any;
  iuf: any;
  erreurModerateurText: string = '';

  // ***** Parcours "Ajouter un intervenant" (nouveau / existant)
  addSpeakerStep: 'choice' | 'role' | 'list' | 'form' | 'recap' | 'import' =
    'choice';
  addSpeakerMode: 'new' | 'existing' | 'import' | null = null;
  selectedSpeakerRole: { name: string; value: string } | null = null;
  existingSpeakers: IntervenantResponse[] = [];
  existingSpeakersLoading: boolean = false;
  existingSpeakersError: boolean = false;
  existingSpeakersErrorText: string = '';
  existingSpeakerSearch: string = '';
  selectedExistingSpeakers: any[] = [];
  pendingModeratorDtos: any[] = [];
  moderatorSuccessText: string = "L'intervenant a été ajouté avec succès.";
  isSubmittingSpeaker: boolean = false;
  // Modal autonome "Importer des intervenants" (écran principal, sans webinaire)
  showImportIntervenantsModal: boolean = false;
  // Import d'intervenants par fichier Excel
  importFile: File | null = null;
  importLoading: boolean = false;
  importErrorText: string = '';
  importResult: {
    totalRows: number;
    imported: number;
    ignored: number;
    errors: string[];
  } | null = null;

  ngOnInit(): void {
    this.user = sessionStorage.getItem('user');
    this.profil = JSON.parse(this.user).profile.id;
    this.role = JSON.parse(this.user)?.roles;
    this.iuf = JSON.parse(this.user).iuf;
    if (this.role.length > 0) {
      this.role.forEach((element: { id: number; roleName: any }) => {
        switch (element.roleName) {
          case 'admin': {
            this.isAdmin = true;
            break;
          }
          case 'gestionnaire-fcc-benin': {
            this.isBeninGestionnaire = true;
            break;
          }
        }
      });
    }
    this.initTestFormControls();
    this.initFormTest();
    this.initMentorForm();
    this.loadParcoursCertificats();
    this.loadCohortes();
    this.loadCertificatCodes();
    this.loadWebinaireTypeOptions();
    this.loadHorsParcoursCertificats();
    this.loadMentoratCertificats();
    this.loadAllCertificats();
    this.route.queryParams.subscribe((params) => {
      const filter = params['filter'];

      if (this.isBeninGestionnaire) {
        this.filterType = 'horsParcours';
      } else if (filter) {
        this.filterType = filter;
      } else {
        this.filterType = 'all';
      }

      this.filterCertificats(this.filterType);
    });
    this.checkTestFormValidity();
    this.syncFormattedDates();
  }

  loadParcoursCertificats(page: number = 0, size: number = 10): void {
    this.spinnerService.showSpinner();
    this.certificatService
      .getSiguiCertificateFromFODEPaged(page, size)
      .pipe(
        tap((response: any) => {
          const paginated = response.object;
          this.paginatedResponseParcoursCertificate = response;
          if (response?.object.content) {
            this.certificatsParcours = paginated.content.map(
              (certificat: any) => {
                certificat.status = this.calculStatus(certificat);
                certificat.certificatType = 'parcours'; // Marquer comme certificat de parcours
                return certificat;
              },
            );
            this.currentPageParcoursCertificate = paginated.number;
            this.pageSizeParcoursCertificate = paginated.size;
            this.totalElementsParcoursCertificate = paginated.totalElements;
          } else {
            console.warn(
              'Response ou content est undefined pour les certificats de parcours',
            );
            this.certificatsParcours = [];
          }
          this.spinnerService.hideSpinner();
        }),
      )
      .subscribe({
        error: (error) => {
          console.error(
            'Erreur lors du chargement des certificats de parcours:',
            error,
          );
          this.spinnerService.hideSpinner();
        },
      });
  }

  loadHorsParcoursCertificats(page: number = 0, size: number = 10): void {
    this.spinnerService.showSpinner();
    const certificatCall$ = this.isBeninGestionnaire
      ? this.certificatService.getHorsParcoursSiguiCertificateBenin(
          page,
          size,
          this.iuf,
        )
      : this.certificatService.getHorsParcoursSiguiCertificateFromFODEPaged(
          page,
          size,
        );
    certificatCall$
      .pipe(
        tap((response: any) => {
          this.paginatedResponseHorsParcoursCertificate = response;
          if (response?.content) {
            this.certificatsHorsParcours = response.content.map(
              (certificat: any) => {
                certificat.status = this.calculStatus(certificat);
                certificat.certificatType = 'horsParcours';
                return certificat;
              },
            );
            this.currentPageHorsParcoursCertificate = response.number;
            this.pageSizeHorsParcoursCertificate = response.size;
            this.totalElementsHorsParcoursCertificate = response.totalElements;
          } else {
            console.warn(
              'Response ou content est undefined pour les certificats hors parcours',
            );
            this.certificatsHorsParcours = [];
          }
          this.spinnerService.hideSpinner();
        }),
      )
      .subscribe({
        error: (error) => {
          console.error(
            'Erreur lors du chargement des certificats hors parcours:',
            error,
          );
          this.spinnerService.hideSpinner();
        },
      });
  }

  loadMentoratCertificats(page: number = 0, size: number = 10) {
    this.spinnerService.showSpinner();
    this.mentoratService
      .getAllCertificateMentoratPaginated(page, size)
      .pipe(
        tap((response: any) => {
          this.paginatedResponseMentoratCertificate = response;
          if (response?.content) {
            this.certifiacatsMentorat = response.content
              .map((certificat: any) => {
                certificat.status = this.calculStatus(certificat);
                certificat.certificatType = 'mentorat';
                return certificat;
              })
              .sort((a: any, b: any) => {
                if (!a.fullname || !b.fullname) return 0;
                return a.fullname.localeCompare(b.fullname);
              });
            this.currentPageMentoratCertificate = response.number;
            this.pageSizeMentoratCertificate = response.size;
            this.totalElementsMentoratCertificate = response.totalElements;
          } else {
            console.warn(
              'Response ou content est undefined pour les certificats de mentorat',
            );
            this.certifiacatsMentorat = [];
          }
          this.spinnerService.hideSpinner();
        }),
      )
      .subscribe({
        error: (error: any) => {
          console.error(
            'Erreur lors du chargement des certificats de mentorat:',
            error,
          );
          this.spinnerService.hideSpinner();
        },
      });
  }

  loadWebinaires(page: number = 0, size: number = 10): void {
    this.spinnerService.showSpinner();
    this.certificatService
      .getWebinairesPaged(page, size)
      .pipe(
        tap((response: any) => {
          const paginated = response;
          this.paginatedResponseWebinaire = response;
          if (response?.content) {
            this.webinaires = paginated.content.map((webinaire: any) => {
              webinaire.status = this.calculStatusWebinaire(webinaire);
              webinaire.certificatType = 'webinaire';
              return webinaire;
            });
            this.currentPageWebinaire = paginated.number;
            this.pageSizeWebinaire = paginated.size;
            this.totalElementsWebinaire = paginated.totalElements;
          } else {
            console.warn(
              'Response ou content est undefined pour les webinaires',
            );
            this.webinaires = [];
          }
          this.spinnerService.hideSpinner();
        }),
      )
      .subscribe({
        error: (error: any) => {
          console.error('Erreur lors du chargement des webinaires:', error);
          this.spinnerService.hideSpinner();
        },
      });
  }

  loadAllCertificats(page: number = 0, size: number = 10): void {
    this.spinnerService.showSpinner();
    this.certificatService
      .getAllCertificatesPaged(page, size)
      .pipe(
        tap((response: PaginatedResponse<UnifiedCertificateDTO>) => {
          this.paginatedResponseAll = response;
          if (response?.content) {
            this.unifiedCertificates = response.content.map(
              (certificat: UnifiedCertificateDTO) => {
                // Ajouter le statut calculé
                (certificat as any).status = this.calculStatus(certificat);
                return certificat;
              },
            );
            this.currentPageAll = response.number;
            this.pageSizeAll = response.size;
            this.totalElementsAll = response.totalElements;
          } else {
            console.warn(
              'Response ou content est undefined pour les certificats unifiés',
            );
            this.unifiedCertificates = [];
          }
          this.spinnerService.hideSpinner();
        }),
      )
      .subscribe({
        error: (error) => {
          console.error(
            'Erreur lors du chargement des certificats unifiés:',
            error,
          );
          this.spinnerService.hideSpinner();
        },
      });
  }

  filterCertificats(type: string): void {
    this.spinnerService.showSpinner();
    this.filterType = type;
    // Réinitialiser la pagination selon le filtre
    if (type === 'parcours' && this.certificatsParcours.length === 0) {
      this.loadParcoursCertificats(0, this.pageSizeParcoursCertificate);
    } else if (
      type === 'horsParcours' &&
      this.certificatsHorsParcours.length === 0
    ) {
      this.loadHorsParcoursCertificats(0, this.pageSizeHorsParcoursCertificate);
    } else if (type === 'webinaire' && this.webinaires.length === 0) {
      this.loadWebinaires(0, this.pageSizeWebinaire);
    }
    switch (type) {
      case 'parcours':
        this.loadParcoursCertificats(0, this.pageSizeParcoursCertificate);
        break;
      case 'horsParcours':
        this.loadHorsParcoursCertificats(
          0,
          this.pageSizeHorsParcoursCertificate,
        );
        break;
      case 'mentorat':
        this.loadMentoratCertificats(0, this.pageSizeMentoratCertificate);
        break;
      default:
        this.loadAllCertificats(0, this.pageSizeAll);
        break;
    }
  }

  onPageChange(event: any): void {
    if (this.filterType === 'parcours') {
      this.currentPageParcoursCertificate = event.pageIndex;
      this.pageSizeParcoursCertificate = event.pageSize;
      this.loadParcoursCertificats(
        this.currentPageParcoursCertificate,
        this.pageSizeParcoursCertificate,
      );
    } else if (this.filterType === 'horsParcours') {
      this.currentPageHorsParcoursCertificate = event.pageIndex;
      this.pageSizeHorsParcoursCertificate = event.pageSize;
      this.loadHorsParcoursCertificats(
        this.currentPageHorsParcoursCertificate,
        this.pageSizeHorsParcoursCertificate,
      );
    } else if (this.filterType === 'webinaire') {
      this.currentPageWebinaire = event.pageIndex;
      this.pageSizeWebinaire = event.pageSize;
      if ((this.webinaireSearchTerm || '').trim()) {
        this.searchWebinaires(
          this.currentPageWebinaire,
          this.pageSizeWebinaire,
        );
      } else {
        this.loadWebinaires(this.currentPageWebinaire, this.pageSizeWebinaire);
      }
    } else if (this.filterType === 'mentorat') {
      this.currentPageMentoratCertificate = event.pageIndex;
      this.pageSizeMentoratCertificate = event.pageSize;
      this.loadMentoratCertificats(
        this.currentPageMentoratCertificate,
        this.pageSizeMentoratCertificate,
      );
    } else if (this.filterType === 'all') {
      this.currentPageAll = event.pageIndex;
      this.pageSizeAll = event.pageSize;
      this.loadAllCertificats(this.currentPageAll, this.pageSizeAll);
    }
  }

  get certificatsToDisplay(): any[] {
    switch (this.filterType) {
      case 'parcours':
        return this.certificatsParcours;
      case 'horsParcours':
        return this.certificatsHorsParcours;
      case 'webinaire':
        return this.webinaires;
      case 'mentorat':
        return this.certifiacatsMentorat;
      case 'all':
      default:
        return this.unifiedCertificates;
    }
  }

  onWebinaireSearchChange(terme: string): void {
    this.webinaireSearchTerm = terme;

    // Debounce simple : on attend 400ms après la dernière frappe
    if (this.webinaireSearchTimeout) {
      clearTimeout(this.webinaireSearchTimeout);
    }
    this.webinaireSearchTimeout = setTimeout(() => {
      this.searchWebinaires(0, this.pageSizeWebinaire);
    }, 400);
  }

  clearWebinaireSearch(): void {
    this.webinaireSearchTerm = '';
    if (this.webinaireSearchTimeout) {
      clearTimeout(this.webinaireSearchTimeout);
    }
    this.loadWebinaires(0, this.pageSizeWebinaire);
  }

  // Appel réel au backend pour la recherche paginée des webinaires
  searchWebinaires(page: number = 0, size: number = 10): void {
    const motCle = (this.webinaireSearchTerm || '').trim();

    if (!motCle) {
      this.loadWebinaires(page, size);
      return;
    }

    this.spinnerService.showSpinner();
    this.certificatService
      .searchWebinaires(motCle, page, size)
      .pipe(
        tap((response: any) => {
          this.paginatedResponseWebinaire = response;
          if (response?.content) {
            this.webinaires = response.content
              .map((webinaire: any) => {
                webinaire.status = this.calculStatusWebinaire(webinaire);
                webinaire.certificatType = 'webinaire';
                return webinaire;
              })
              .sort((a: any, b: any) => {
                if (!a.name || !b.name) return 0;
                return a.name.localeCompare(b.name);
              });
            this.currentPageWebinaire = response.number;
            this.pageSizeWebinaire = response.size;
            this.totalElementsWebinaire = response.totalElements;
          } else {
            this.webinaires = [];
            this.totalElementsWebinaire = 0;
          }
          this.spinnerService.hideSpinner();
        }),
      )
      .subscribe({
        error: (error) => {
          console.error('Erreur lors de la recherche des webinaires:', error);
          this.spinnerService.hideSpinner();
        },
      });
  }

  get currentTotalElements(): number {
    switch (this.filterType) {
      case 'parcours':
        return this.totalElementsParcoursCertificate;
      case 'horsParcours':
        return this.totalElementsHorsParcoursCertificate;
      case 'webinaire':
        return this.totalElementsWebinaire;
      case 'mentorat':
        return this.totalElementsMentoratCertificate;
      case 'all':
      default:
        return this.totalElementsAll;
    }
  }

  get currentPageSize(): number {
    switch (this.filterType) {
      case 'parcours':
        return this.pageSizeParcoursCertificate;
      case 'horsParcours':
        return this.pageSizeHorsParcoursCertificate;
      case 'webinaire':
        return this.pageSizeWebinaire;
      case 'mentorat':
        return this.pageSizeMentoratCertificate;
      case 'all':
      default:
        return this.pageSizeAll;
    }
  }

  get currentPageIndex(): number {
    switch (this.filterType) {
      case 'parcours':
        return this.currentPageParcoursCertificate;
      case 'horsParcours':
        return this.currentPageHorsParcoursCertificate;
      case 'webinaire':
        return this.currentPageWebinaire;
      case 'mentorat':
        return this.currentPageMentoratCertificate;
      case 'all':
      default:
        return this.currentPageAll;
    }
  }

  private initTestFormControls(): void {
    this.nameCtrl = this.formBuilder.control('', Validators.required);
    this.openDateCtrl = this.formBuilder.control('', Validators.required);
    this.closeDateCtrl = this.formBuilder.control('', Validators.required);
    this.accessLinkCtrl = this.formBuilder.control('', Validators.required);
    this.selectedCohortCtrl = this.formBuilder.control('', Validators.required);
    this.isPublicCtrl = this.formBuilder.control('');
    this.createdByCtrl = this.formBuilder.control('');
    this.createdAtCtrl = this.formBuilder.control('');
    this.updatedAtCtrl = this.formBuilder.control('');
    this.idCertificatCtrl = this.formBuilder.control('');
  }

  private initFormTest(): void {
    this.testForm = this.formBuilder.group({
      name: this.nameCtrl,
      openDate: this.openDateCtrl,
      closeDate: this.closeDateCtrl,
      accessLink: this.accessLinkCtrl,
      cohorte: this.selectedCohortCtrl,
      isPublic: this.isPublicCtrl,
      createdBy: this.createdByCtrl,
      createdAt: this.createdAtCtrl,
      updatedAt: this.updatedAtCtrl,
      idCertificat: this.idCertificatCtrl,
    });
  }
  loadCohortes(): void {
    this.certificatService.getAllCohortesParcoursImproved().subscribe({
      next: (cohortesList: any[]) => {
        this.cohortesList = cohortesList;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des cohortes:', error);
        this.cohortesList = [];
      },
    });
  }

  loadCertificatCodes(): void {
    this.certificatService.getAllCertificatCodes().subscribe({
      next: (codes) => {
        this.certificatCodes = codes;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des certificatCodes:', error);
        this.certificatCodes = [];
      },
    });
  }

  loadWebinaireTypeOptions(): void {
    this.applicationSimplifyService.getWebinarTypeOptions().subscribe({
      next: (types) => {
        this.webinaireTypeOptions = (types || []).map((type) => ({
          value: type,
          label: type,
        }));
      },
      error: (error) => {
        console.error(
          'Erreur lors du chargement des types de webinaire:',
          error,
        );
        this.webinaireTypeOptions = [];
      },
    });
  }
  onSubmitTestForm() {
    this.idCertificatCtrl.setValue(this.selectedCertificat.externalId);

    if (this.testForm.valid) {
      const test: NewTestQualification = this.testForm.value;

      this.certificatService
        .addTestToCertificate(test)
        .pipe(
          tap((customResponse: CustomResponse) => {
            if (customResponse.status === 200) {
              this.testForm.reset();
              this.inValid = false;
              this.isSucces = true;

              const certIdForTests =
                this.selectedCertificat.certificatType === 'parcours'
                  ? this.selectedCertificat.id_certificate
                  : this.selectedCertificat.id;
              this.getTestByIdCertificate(certIdForTests);
              setTimeout(() => {
                this.isSucces = false;
                this.showTestFormModal = false;
              }, 3000);
            } else {
              this.serverError = true;

              setTimeout(() => {
                this.serverError = false;
              }, 3000);
            }
          }),
        )
        .subscribe();
    } else {
      this.markInvalidField('name');
      this.markInvalidField('openDate');
      this.markInvalidField('closeDate');
      this.markInvalidField('accessLink');
      this.markInvalidField('cohorte');

      this.inValid = true;
      this.isSucces = false;
    }
  }

  //CHANGEMENT DE METHODE POUR ADAPTER LE CALCUL SUR LES DATE AFIN DAVOIR DES STATUT CONFORME

  private calculStatus(certificat: any): string {
    // Récupérer les dates selon le format du certificat
    const startValue = certificat.startdate ?? certificat.startDate;
    const endValue = certificat.enddate ?? certificat.endDate;

    // Si aucune date de fin n'est renseignée
    if (
      endValue === null ||
      endValue === undefined ||
      endValue === '' ||
      endValue === 0
    ) {
      return 'En cours';
    }

    const now = new Date().getTime();

    // Conversion robuste de la date de début
    let startDate: number;

    if (typeof startValue === 'number') {
      // Timestamp Unix en secondes ou millisecondes
      startDate = startValue < 1e10 ? startValue * 1000 : startValue;
    } else {
      // Date ISO/String
      startDate = new Date(startValue).getTime();
    }

    // Conversion robuste de la date de fin
    let endDate: number;

    if (typeof endValue === 'number') {
      // Timestamp Unix en secondes ou millisecondes
      endDate = endValue < 1e10 ? endValue * 1000 : endValue;
    } else {
      // Date ISO/String
      endDate = new Date(endValue).getTime();
    }

    // Vérifier que les dates sont valides
    if (isNaN(startDate) || isNaN(endDate)) {
      console.warn('Dates invalides pour le certificat :', certificat);
      return 'En cours';
    }

    // Pas encore commencé
    if (startDate > now) {
      return 'En attente';
    }

    // Commencé mais pas encore terminé
    if (endDate > now) {
      return 'En cours';
    }

    // Date de fin dépassée
    return 'Terminé';
  }

  private calculStatusWebinaire(webinaire: any): string {
    if (!webinaire.date) {
      return 'En cours';
    }

    const now = new Date();
    const webinarDate = new Date(webinaire.date);

    const year = webinarDate.getFullYear();
    const month = webinarDate.getMonth();
    const day = webinarDate.getDate();

    if (webinaire.startTime && webinaire.endTime) {
      const [startH, startM, startS] = webinaire.startTime
        .split(':')
        .map(Number);
      const [endH, endM, endS] = webinaire.endTime.split(':').map(Number);

      const startDateTime = new Date(year, month, day, startH, startM, startS);
      const endDateTime = new Date(year, month, day, endH, endM, endS);

      if (now < startDateTime) {
        return 'En attente';
      } else if (now >= startDateTime && now <= endDateTime) {
        return 'En cours';
      } else {
        return 'Terminé';
      }
    }

    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const wDate = new Date(year, month, day);

    if (wDate > today) {
      return 'En attente';
    } else if (wDate.getTime() === today.getTime()) {
      return 'En cours';
    } else {
      return 'Terminé';
    }
  }

  ViewCertificateDetails(selected: any): void {
    this.editCertificatMode = false;
    this.showCertificatDetailsModal = true;
    this.selectedCertificat = { ...selected };
    this.selectedHorsParcoursCertificat = this.selectedCertificat;

    this._normalizeCertificatFields(this.selectedCertificat);

    const certIdForTests =
      this.selectedCertificat.certificatType === 'parcours'
        ? this.selectedCertificat.id_certificate
        : this.selectedCertificat.id;
    this.getTestByIdCertificate(certIdForTests);

    if (selected.certificatType === 'webinaire') {
      this.getModeratorsbyWebinar(selected.id);
    }
  }

  ViewCertificateDetailsToModifie(selected: any): void {
    this.editCertificatMode = true;
    this.showCertificatDetailsModal = true;
    this.selectedCertificat = { ...selected };
    this.selectedHorsParcoursCertificat = this.selectedCertificat;

    this._normalizeCertificatFields(this.selectedCertificat);

    const certIdForTests =
      this.selectedCertificat.certificatType === 'parcours'
        ? this.selectedCertificat.id_certificate
        : this.selectedCertificat.id;

    this.getTestByIdCertificate(certIdForTests);

    if (selected.certificatType === 'webinaire') {
      this.getModeratorsbyWebinar(selected.id);
    }
  }

  private _normalizeCertificatFields(cert: any): void {
    if (cert.certificatType === 'parcours') {
      cert._startDateInput = cert.startdate
        ? this._timestampToDateInput(cert.startdate)
        : '';
      cert._endDateInput = cert.enddate
        ? this._timestampToDateInput(cert.enddate)
        : '';
      // id_certificate = l'id Moodle = la PK du back
      cert._updateId = cert.id_certificate;
      cert.urlCertificat = cert.urlCertificat || cert.urlCertificate || '';
      cert._selectedCertificatCode = cert.certificatCode || null;
    } else if (cert.certificatType === 'horsParcours') {
      cert._startDateInput = cert.startDate || cert.startdate || '';
      cert._endDateInput = cert.endDate || cert.enddate || '';
      cert._updateId = cert.id;
      cert.certifcatCategory =
        cert.certifcatCategory || cert.certificatCategory;
      cert.cohorte = cert.cohorte || cert.offTrackCohort || '';
      cert.urlCertificat = cert.urlCertificat || cert.urlCertificate || '';
      cert._selectedCertificatCode = cert.certificatCode || null;
      cert._originalExternalId = cert.externalId;
    }

    // Récupération de la catégorie sélectionnée
    cert._selectedCategoryId =
      cert.certifcatCategory?.id ??
      cert.category?.id ??
      cert.categoryId ??
      null;
  }

  private _timestampToDateInput(ts: number): string {
    if (!ts) return '';
    // Si le timestamp est déjà en millisecondes (> 1e10), on ne divise pas
    const ms = ts > 1e10 ? ts : ts * 1000;
    const d = new Date(ms);
    return d.toISOString().split('T')[0];
  }

  confirmUpdateCertificat() {
    this.saveCertificatModifications(); // Exécute l'enregistrement
    this.showConfirmUpdateModal = false; // Ferme la popup
  }

  private normalizeTime(time: string): string {
    if (!time) return time;
    return time.length === 5 ? `${time}:00` : time;
  }
  saveCertificatModifications() {
    const cert = this.selectedCertificat;
    if (cert.certificatType === 'webinaire') {
      const webinarSimplifyDto = {
        id: cert.id,
        idZoom: cert.idZoom,
        name: cert.name,
        shortname: cert.shortname,
        displayName: cert.displayName,
        date: cert.date,
        startTime: this.normalizeTime(cert.startTime),
        endTime: this.normalizeTime(cert.endTime),
        urlZoom: cert.urlZoom,
        plateforme: cert.plateforme,
        description: cert.description,
        cohorte: cert.cohorte,
        objectif: cert.objectif,
        webinaireType: cert.webinaireType,
        createdBy: cert.createdBy,
        urlJokko: cert.urlJokko,
        zoomAccount: cert.zoomAccount,
      };
      this.certificatService
        .updateWebinar(webinarSimplifyDto.id, webinarSimplifyDto)
        .pipe(
          tap(() => {
            this.editCertificatMode = false;
            this.showConfirmUpdateModal = false;
            // Snackbar succès
            this.updateMessage = 'Certificat modifié avec succès';
            this.updateSucces = true;
            this.updateWebinarError = false;
            this.updateWebinarErrorText = '';

            setTimeout(() => {
              this.updateSucces = false;
              this.updateMessage = '';
              this.showCertificatDetailsModal = false;
            }, 5000);

            this.loadWebinaires(0, this.pageSizeWebinaire);
          }),
          catchError((err: HttpErrorResponse) => {
            console.error('Erreur lors de la mise à jour', err);
            this.showConfirmUpdateModal = false;
            this.updateWebinarErrorText =
              err?.error?.message ||
              'Erreur lors de la mise à jour du certificat';
            this.updateWebinarError = true;
            return of(null);
          }),
        )
        .subscribe();
    } else {
      const id =
        cert.certificatType === 'parcours' ? cert.id_certificate : cert.id;

      if (id === null || id === undefined || id === '') {
        console.error("L'ID du certificat est manquant !");
        return;
      }

      const selectedCategoryId =
        cert._selectedCategoryId || cert.certifcatCategory?.id;

      let startTs: any, endTs: any;
      if (cert.certificatType === 'parcours') {
        startTs = cert._startDateInput
          ? Math.floor(new Date(cert._startDateInput).getTime() / 1000)
          : cert.startdate;
        endTs = cert._endDateInput
          ? Math.floor(new Date(cert._endDateInput).getTime() / 1000)
          : cert.enddate;
      } else {
        startTs = cert._startDateInput;
        endTs = cert._endDateInput;
      }

      let updatedCertificatData: any;

      if (cert.certificatType === 'parcours') {
        // Champs alignés sur NewParcourCertificateDTO (backend)
        updatedCertificatData = {
          name: cert.name,
          shortname: cert.shortname,
          fullname: cert.fullname,
          displayName: cert.displayname || cert.displayName,
          startdate: startTs,
          enddate: endTs,
          urlCertificate: cert.urlCertificat || cert.urlCertificate || null,
          plateforme: cert.plateforme || null,
          description: cert.description || null,
          cohorte: cert.cohorte || null,
          categoryId: selectedCategoryId ? Number(selectedCategoryId) : null,
          certificatCode: cert._selectedCertificatCode || null,
          externalId: cert.externalId ? String(cert.externalId) : null,
        };
      } else {
        // Hors parcours
        updatedCertificatData = {
          externalId: String(cert.externalId),
          name: cert.name,
          shortname: cert.shortname,
          fullname: cert.fullname,
          displayName: cert.displayname || cert.displayName,
          startDate: cert._startDateInput || null,
          endDate: cert._endDateInput || null,
          urlCertificate: cert.urlCertificat || cert.urlCertificate || null,
          plateforme: cert.plateforme || null,
          description: cert.description || null,
          urlImage: cert.urlImage || null,
          offTrackCohort: cert.cohorte || cert.offTrackCohort || null,
          categoryId: selectedCategoryId ? Number(selectedCategoryId) : null,
          certificatCode: cert._selectedCertificatCode || null,
        };
      }

      const update$ =
        cert.certificatType === 'parcours'
          ? this.certificatService.updateCertificat(id, updatedCertificatData)
          : this.certificatService.updateCertificatHp(
              cert._originalExternalId, // ancienne valeur, pour l'URL
              updatedCertificatData,
            );

      update$.subscribe({
        next: () => {
          this.editCertificatMode = false;
          this.showConfirmUpdateModal = false;
          // Snackbar succès
          this.updateMessage = 'Certificat modifié avec succès';
          this.updateSucces = true;
          setTimeout(() => {
            this.updateSucces = false;
            this.updateMessage = '';
            this.showCertificatDetailsModal = false;
          }, 3500);

          if (cert.certificatType === 'parcours') {
            this.loadParcoursCertificats(
              this.currentPageParcoursCertificate,
              this.pageSizeParcoursCertificate,
            );
          } else {
            this.loadHorsParcoursCertificats(
              this.currentPageHorsParcoursCertificate,
              this.pageSizeHorsParcoursCertificate,
            );
          }
        },
        error: (err) => {
          console.error('Erreur lors de la mise à jour', err);
          this.showConfirmUpdateModal = false;
          // Snackbar erreur
          this.updateMessage =
            err?.error?.message ||
            'Erreur lors de la mise à jour du certificat';
          this.updateError = true;
          setTimeout(() => {
            this.updateError = false;
            this.updateMessage = '';
          }, 3500);
        },
      });
    }
  }

  syncFormattedDates() {
    if (this.selectedCertificat?.startdate) {
      this.formattedStartDate = this.convertTimestampToDateInput(
        this.selectedCertificat.startdate,
      );
    }

    if (this.selectedCertificat?.enddate) {
      this.formattedEndDate = this.convertTimestampToDateInput(
        this.selectedCertificat.enddate,
      );
    }
  }

  convertTimestampToDateInput(timestamp: number): string {
    const date = new Date(timestamp * 1000);
    return date.toISOString().split('T')[0];
  }

  convertDateInputToTimestamp(dateStr: string): number {
    return Math.floor(new Date(dateStr).getTime() / 1000);
  }

  closeDetails() {
    this.showCertificatDetailsModal = false;
  }
  getCertificatCodeLabel(code: string | null): string | null {
    if (!code) return null;
    return this.certificatCodes.find((c) => c.code === code)?.label || code;
  }
  ViewTestForm(title: string): void {
    this.showTestFormModal = true;
    this.testFormTitle = title;
    this.addButton = true;
    this.updateButton = false;
  }

  closeTestModal() {
    this.showTestFormModal = false;
  }

  markInvalidField(controlName: string) {
    const control = this.testForm.get(controlName);

    if (control && control.invalid) {
      control.markAsTouched();
    }
  }

  isFieldInvalid(controlName: string): boolean | null {
    const control = this.testForm.get(controlName);

    return control && control.invalid && control.touched;
  }

  checkTestFormValidity() {
    this.testForm.statusChanges
      .pipe(
        tap((status) => {
          if (status === 'VALID') {
            this.inValid = false;
          }
        }),
      )
      .subscribe();
  }

  getTestByIdCertificate(certificateId: number) {
    if (!certificateId) {
      this.testsByCertificate = [];
      return;
    }
    this.testsByCertificate = [];
    this.certificatService
      .getTestByCertificateId(certificateId)
      .pipe(
        tap((test) => {
          this.testsByCertificate = Array.isArray(test)
            ? test
            : test?.object || [];
        }),
      )
      .subscribe({
        error: (err) => {
          console.error('Erreur chargement tests:', err);
          this.testsByCertificate = [];
        },
      });
  }

  onViewTestDetails(accesLink: string) {
    window.open(accesLink, '_blank');
  }
  onDeleteTest() {
    this.certificatService
      .deleteTestById(this.selectedTest.id)
      .pipe(
        tap((response: CustomResponse) => {
          if (response.status === 200) {
            const certIdForTests =
              this.selectedCertificat.certificatType === 'parcours'
                ? this.selectedCertificat.id_certificate
                : this.selectedCertificat.id;
            this.getTestByIdCertificate(certIdForTests);
            this.showDeleteModal = false;
          } else {
            this.deleteError = true;

            setTimeout(() => {
              this.deleteError = false;
            }, 3000);
          }
        }),
      )
      .subscribe();
  }

  onViewTestFormForUpdate(selectedTest: NewTestQualification, title: string) {
    this.testFormTitle = title;
    this.showTestFormModal = true;
    this.addButton = false;
    this.updateButton = true;
    this.selectedTest = selectedTest;

    this.testForm.patchValue({
      name: selectedTest.name,
      openDate: selectedTest.openDate,
      closeDate: selectedTest.closeDate,
      accessLink: selectedTest.accessLink,
      cohorte: selectedTest.cohorte,
    });
  }
  onUpdateTestForm() {
    this.idCertificatCtrl.setValue(this.selectedCertificat.externalId);

    if (this.testForm.valid) {
      const test: NewTestQualification = this.testForm.value;
      this.certificatService
        .updateTest(test, this.selectedTest.id)
        .pipe(
          tap((customResponse: CustomResponse) => {
            if (customResponse.status === 200) {
              this.testForm.reset();
              this.inValid = false;
              this.isUpdate = true;

              const certIdForTests =
                this.selectedCertificat.certificatType === 'parcours'
                  ? this.selectedCertificat.id_certificate
                  : this.selectedCertificat.id;
              this.getTestByIdCertificate(certIdForTests);
              setTimeout(() => {
                this.isUpdate = false;
                this.showTestFormModal = false;
              }, 3000);
            } else {
              this.serverError = true;

              setTimeout(() => {
                this.serverError = false;
              }, 3000);
            }
          }),
        )
        .subscribe();
    } else {
      this.markInvalidField('name');
      this.markInvalidField('openDate');
      this.markInvalidField('closeDate');
      this.markInvalidField('accessLink');
      this.markInvalidField('cohorte');

      this.inValid = true;
      this.isUpdate = false;
    }
  }

  onViewModalDelete(selectedTest: NewTestQualification) {
    this.selectedTest = selectedTest;
    this.showDeleteModal = true;
  }

  closeSuppModal() {
    this.showDeleteModal = false;
  }

  addUserModal() {
    this.addUser = true;
  }

  closeAddUserModal() {
    this.addUser = false;
  }

  expectedHeaders = [
    'Prénom',
    'Nom',
    'Date de naissance',
    'Sexe',
    'Numéro de téléphone',
    'Ce numéro est-il disponible sur Whatsapp?',
    'Numéro de Whatsapp',
    'Email',
    'Nationalité',
    'Précisez votre nationalité',
    'Diplôme le plus élevé obtenu (ou équivalent)',
    'Statut actuel',
    'Région de résidence',
    'Précisez la région de résidence',
    'Zone de résidence',
  ];

  onFileChange(event: any) {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      this.file = file;
      this.fileSize = file.size;
      this.fileName = file.name;

      // Lire fichier CSV
      if (file.name.endsWith('.csv')) {
        reader.onload = (e: any) => {
          const csvData = e.target.result;
          this.validateCSVHeaders(csvData);
        };
        reader.readAsText(file);

        // Lire fichier Excel
      } else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
        reader.onload = (e: any) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const excelData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
          this.validateExcelHeaders(excelData);
        };
        reader.readAsArrayBuffer(file);
      } else {
        alert('Veuillez télécharger un fichier CSV ou Excel valide.');
      }
    }
  }

  // Validation des entêtes pour les fichiers CSV
  validateCSVHeaders(csvData: string): void {
    const firstRow = csvData.split('\n')[0].split(',');
    this.validateHeaders(firstRow);
  }

  // Validation des entêtes pour les fichiers Excel
  validateExcelHeaders(excelData: any[]): void {
    const firstRow = excelData[0];
    this.validateHeaders(firstRow);
  }

  // Validation commune pour vérifier que les entêtes sont conformes
  validateHeaders(headers: any[]): void {
    let isValid = true;

    this.expectedHeaders.forEach((value) => {
      if (!headers.includes(value)) {
        isValid = false;
      }
    });

    if (isValid) {
      this.fileIsValid = true;
    } else {
      this.fileIsValid = false;
      alert(
        `Les entêtes ne sont pas conformes. Entêtes attendues: ${this.expectedHeaders.join(
          ', ',
        )}`,
      );
    }
  }

  enrolment() {
    if (this.file) {
      const formData = new FormData();
      formData.append('file', this.file);
      this.spinnerService.showSpinner();

      this.certificatService
        .enrollMultiple(formData, this.selectedCertificat.id)
        .pipe()
        .subscribe({
          next: (response) => {
            if (response.status == 200) {
              this.mutliNotif = true;
              this.spinnerService.hideSpinner();

              setTimeout(() => {
                this.mutliNotif = false;
              }, 5000);
            } else {
              this.saveError = true;
              this.spinnerService.hideSpinner();

              setTimeout(() => {
                this.saveError = false;
              }, 3000);
            }
          },
          error: () => {
            this.spinnerService.hideSpinner();
            this.multiError = true;

            setTimeout(() => {
              this.multiError = false;
            }, 3000);
          },
        });
    } else {
      this.noFile = true;

      setTimeout(() => {
        this.noFile = false;
      }, 2000);
    }
  }

  breadrumbItems: BreadcrumbItem[] = [
    { label: 'SIGUI' },
    {
      label: 'GESTION DES CERTIFICATS',
      url: '/dashboard/appels/sigui-certificat',
    },
  ];

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event): void {
    const dropdownElement = (event.target as HTMLElement).closest('.relative');
    if (!dropdownElement && this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }

  //***** Méthodes pour la gestion des intervenants (modérateurs / animateurs)
  initMentorForm(): void {
    this.mentorForm = this.formBuilder.group({
      civility: [null],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      bioModerator: [''],
      role: ['', Validators.required],
    });
  }

  // La civilité est obligatoire pour un nouvel intervenant (elle alimente la table Intervenants),
  // facultative quand on part d'une fiche existante.
 private setCivilityRequired(required: boolean): void {
  const ctrl = this.mentorForm?.get('civility');
  if (!ctrl) return;
  ctrl.setValidators(required ? Validators.required : null);
  ctrl.updateValueAndValidity();
  this.mentorForm.updateValueAndValidity();
}

 private createModerator(webinarId: number, dto: any): void {
  const { civility, ...moderatorDto } = dto;

  this.applicationSimplifyService
    .createModerator(webinarId, moderatorDto)
    .subscribe({
      next: () => {
        this.spinnerService.hideSpinner();
        if (this.addSpeakerMode === 'new') {
          this.registerIntervenant(dto);
        }
        this.moderatorSuccessText = "L'intervenant a été ajouté avec succès.";
        this.moderatorSuccess = true;
        setTimeout(() => {
          this.moderatorSuccess = false;
          this.closeAddModeratorModal();
          this.getModeratorsbyWebinar(webinarId);
        }, 5000);
      },
      error: (err) => {
        this.spinnerService.hideSpinner();
        this.isSubmittingSpeaker = false;
        console.error('Erreur lors de la création du modérateur', err);
        this.moderatorError = true;
        this.erreurModerateurText =
          err.error?.message || 'Une erreur inattendue est survenue';
      },
    });
}

  // Enregistre un nouvel intervenant dans la table Intervenants (pour le retrouver ensuite dans "Intervenant existant").
  // Un échec ici ne bloque pas l'ajout au webinaire, déjà réussi.
  private registerIntervenant(dto: any): void {
    this.applicationSimplifyService
      .createIntervenant({
        email: dto.email,
        civility: dto.civility || undefined,
        firstName: dto.firstName,
        lastName: dto.lastName,
        role: dto.eModerator, // 'MODERATOR' | 'PANELISTE'
      })
      .subscribe({
        error: (err: any) =>
          console.error(
            "Erreur lors de l'enregistrement de l'intervenant",
            err,
          ),
      });
  }

  // Ajout de plusieurs intervenants existants en une fois
  private createModerators(webinarId: number, dtos: any[]): void {
    const calls = dtos.map((dto) => {
      const { civility, ...moderatorDto } = dto;
      return this.applicationSimplifyService
        .createModerator(webinarId, moderatorDto)
        .pipe(
          map(() => null),
          catchError((err) =>
            of(
              `${dto.firstName} ${dto.lastName} : ${err?.error?.message || 'erreur inattendue'}`,
            ),
          ),
        );
    });

    forkJoin(calls).subscribe((results) => {
      this.spinnerService.hideSpinner();
      const errors = results.filter((r): r is string => !!r);
      const added = dtos.length - errors.length;
      this.getModeratorsbyWebinar(webinarId);

      if (errors.length === 0) {
        this.moderatorSuccessText =
          added > 1
            ? `${added} intervenants ont été ajoutés avec succès.`
            : "L'intervenant a été ajouté avec succès.";
        this.moderatorSuccess = true;
        setTimeout(() => {
          this.moderatorSuccess = false;
          this.closeAddModeratorModal();
        }, 5000);
      } else {
        // On retire de la sélection ceux qui ont bien été ajoutés
        this.selectedExistingSpeakers = this.selectedExistingSpeakers.filter(
          (s) =>
            errors.some((e) => e.startsWith(`${s.firstName} ${s.lastName} :`)),
        );
        this.moderatorError = true;
        this.erreurModerateurText =
          (added > 0 ? `${added} intervenant(s) ajouté(s). ` : '') +
          `Échec pour : ${errors.join(' — ')}`;
      }
    });
  }

  onSubmitModerator(): void {
    if (this.isSubmittingSpeaker) return;
    if (this.mentorForm.invalid) {
      this.mentorForm.markAllAsTouched();
      return;
    }

    const formValue = this.mentorForm.value;
    this.pendingModeratorDtos = [];
    this.pendingModeratorDto = {
      civility: formValue.civility || null,
      firstName: (formValue.firstName || '').trim(),
      lastName: (formValue.lastName || '').trim(),
      email: (formValue.email || '').trim(),
      bioModerator: formValue.bioModerator || null,
      eModerator: formValue.role,
    };

    this.showConfirmModeratorModal = true;
  }

  confirmModeratorCreation(): void {
  this.showConfirmModeratorModal = false;
  const webinarId = this.selectedCertificat.id;
  this.spinnerService.showSpinner();
  this.isSubmittingSpeaker = true;

  // Plusieurs intervenants existants sélectionnés
  if (this.pendingModeratorDtos.length > 0) {
    this.createModerators(webinarId, this.pendingModeratorDtos);
    this.pendingModeratorDtos = [];
    return;
  }

  this.createModerator(webinarId, this.pendingModeratorDto);
  this.pendingModeratorDto = null;
}

  cancelModeratorCreation(): void {
    this.showConfirmModeratorModal = false;
    this.pendingModeratorDto = null;
    this.pendingModeratorDtos = [];
  }

  getModeratorsbyWebinar(webinarId: number): void {
    this.moderatorsByWebinar = [];
    this.applicationSimplifyService
      .getModeratorsByWebinarId(webinarId)
      .subscribe({
        next: (response) => {
          this.moderatorsByWebinar = response ?? [];
        },
        error: (err) => {
          console.error('Erreur lors du chargement des modérateurs', err);
        },
      });
  }

  openAddModeratorModal(): void {
    this.mentorForm.reset();
    this.resetAddSpeakerFlow();
    this.addMentor = true;
  }

  closeAddModeratorModal(): void {
    this.addMentor = false;
    this.resetAddSpeakerFlow();
  }

  //***** Parcours "Ajouter un intervenant" : nouveau / existant → rôle → liste → informations
  private resetAddSpeakerFlow(): void {
    this.addSpeakerStep = 'choice';
    this.addSpeakerMode = null;
    this.selectedSpeakerRole = null;
    this.existingSpeakers = [];
    this.existingSpeakersLoading = false;
    this.existingSpeakersError = false;
    this.existingSpeakersErrorText = '';
    this.existingSpeakerSearch = '';
    this.selectedExistingSpeakers = [];
    this.pendingModeratorDtos = [];
    this.moderatorError = false;
    this.moderatorSuccess = false;
    this.isSubmittingSpeaker = false;
    this.setCivilityRequired(false);
    this.resetImport();
  }

  get addSpeakerTitle(): string {
    switch (this.addSpeakerStep) {
      case 'role':
        return 'Intervenant existant';
      case 'list':
        return `Choisir des ${(this.selectedSpeakerRole?.name || 'intervenant').toLowerCase()}s`;
      case 'recap':
        return 'Vérifier la sélection';
      case 'form':
        return this.addSpeakerMode === 'existing'
          ? "Vérifier l'intervenant"
          : 'Nouvel intervenant';
      case 'import':
        return 'Importer des intervenants';
      case 'choice':
      default:
        return 'Ajouter un intervenant';
    }
  }

  get addSpeakerSteps(): {
    label: string;
    state: 'done' | 'current' | 'next';
  }[] {
    const steps =
      this.addSpeakerMode === 'existing'
        ? [
            { key: 'choice', label: 'Type' },
            { key: 'role', label: 'Rôle' },
            {
              key: 'list',
              label: this.selectedSpeakerRole
                ? `${this.selectedSpeakerRole.name}s`
                : 'Intervenant',
            },
            {
              key: this.addSpeakerStep === 'recap' ? 'recap' : 'form',
              label:
                this.addSpeakerStep === 'recap'
                  ? 'Récapitulatif'
                  : 'Informations',
            },
          ]
        : this.addSpeakerMode === 'import'
          ? [
              { key: 'choice', label: 'Type' },
              { key: 'import', label: 'Import fichier' },
            ]
          : [
              { key: 'choice', label: 'Type' },
              { key: 'form', label: 'Informations' },
            ];
    const currentIndex = steps.findIndex((s) => s.key === this.addSpeakerStep);
    return steps.map((s, i) => ({
      label: s.label,
      state:
        i < currentIndex ? 'done' : i === currentIndex ? 'current' : 'next',
    }));
  }

  chooseNewSpeaker(): void {
    this.addSpeakerMode = 'new';
    this.selectedExistingSpeakers = [];
    this.mentorForm.reset();
    this.setCivilityRequired(true);
    this.addSpeakerStep = 'form';
  }

  chooseExistingSpeaker(): void {
    this.addSpeakerMode = 'existing';
    this.setCivilityRequired(false);
    this.addSpeakerStep = 'role';
  }

  //***** Import d'intervenants par fichier Excel (POST /fodev2/api/intervenants/import)
  chooseImportSpeakers(): void {
    this.addSpeakerMode = 'import';
    this.resetImport();
    this.addSpeakerStep = 'import';
  }

  //***** Import autonome depuis l'écran principal : alimente uniquement l'annuaire
  // (table Intervenants), aucun lien avec un webinaire.
  openImportIntervenantsModal(): void {
    this.resetImport();
    this.showImportIntervenantsModal = true;
  }

  closeImportIntervenantsModal(): void {
    if (this.importLoading) return;
    this.showImportIntervenantsModal = false;
    this.resetImport();
  }

  resetImport(): void {
    this.importFile = null;
    this.importLoading = false;
    this.importErrorText = '';
    this.importResult = null;
  }

  onImportFileChange(event: any): void {
    const file: File | undefined = event?.target?.files?.[0];
    this.importErrorText = '';
    if (!file) return;
    if (!file.name.toLowerCase().endsWith('.xlsx')) {
      this.importFile = null;
      this.importErrorText = 'Seuls les fichiers .xlsx sont acceptés.';
      event.target.value = '';
      return;
    }
    if (file.size > this.maxFileSize) {
      this.importFile = null;
      this.importErrorText = 'Le fichier est trop volumineux (5 Mo maximum).';
      event.target.value = '';
      return;
    }
    this.importFile = file;
  }

  submitImportSpeakers(): void {
    if (!this.importFile || this.importLoading) return;
    this.importLoading = true;
    this.importErrorText = '';
    this.applicationSimplifyService
      .importIntervenants(this.importFile)
      .subscribe({
        next: (result: any) => {
          this.importLoading = false;
          this.importResult = {
            totalRows: result?.totalRows ?? 0,
            imported: result?.imported ?? 0,
            ignored: result?.ignored ?? 0,
            errors: result?.errors ?? [],
          };
        },
        error: (err: any) => {
          this.importLoading = false;
          this.importErrorText =
            err?.error?.message || "Erreur lors de l'import du fichier.";
        },
      });
  }

  // Modèle Excel conforme à ce que lit le backend (colonnes A à E, ligne 1 = en-têtes)
  downloadIntervenantsTemplate(): void {
    const rows = [
      ['Email', 'Civilité', 'Prénom', 'Nom', 'Rôle'],
      ['exemple.animateur@exemple.com', 'Mme', 'Awa', 'Exemple', 'Animateur'],
      [
        'exemple.moderateur@exemple.com',
        'M.',
        'Moussa',
        'Exemple',
        'Modérateur',
      ],
    ];
    const sheet = XLSX.utils.aoa_to_sheet(rows);
    sheet['!cols'] = [
      { wch: 34 },
      { wch: 10 },
      { wch: 16 },
      { wch: 16 },
      { wch: 14 },
    ];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, 'Intervenants');
    XLSX.writeFile(workbook, 'modele-intervenants.xlsx');
  }

  selectSpeakerRole(role: { name: string; value: string }): void {
    this.selectedSpeakerRole = role;
    this.selectedExistingSpeakers = [];
    this.existingSpeakerSearch = '';
    this.addSpeakerStep = 'list';
    this.loadExistingSpeakers(role.value);
  }

  // Liste des intervenants depuis la table Intervenants (GET /fodev2/api/intervenants?role=...)
  loadExistingSpeakers(role: string): void {
    this.existingSpeakers = [];
    this.existingSpeakersLoading = true;
    this.existingSpeakersError = false;
    this.existingSpeakersErrorText = '';
    this.applicationSimplifyService.getSpeakersByRole(role).subscribe({
      next: (response: IntervenantResponse[]) => {
        this.existingSpeakers = response ?? [];
        this.existingSpeakersLoading = false;
      },
      error: (err: any) => {
        console.error('Erreur lors du chargement des intervenants', err);
        this.existingSpeakersLoading = false;
        this.existingSpeakersError = true;
        this.existingSpeakersErrorText = `(${err?.status ?? '?'}) ${
          err?.error?.message || err?.message || 'Erreur inconnue'
        }`;
      },
    });
  }

  get filteredExistingSpeakers(): IntervenantResponse[] {
    const term = (this.existingSpeakerSearch || '').trim().toLowerCase();
    if (!term) return this.existingSpeakers;
    return this.existingSpeakers.filter((s) =>
      `${s.firstName || ''} ${s.lastName || ''} ${s.email || ''}`
        .toLowerCase()
        .includes(term),
    );
  }

  private speakerKey(speaker: any): string {
    return (speaker?.email || '').toLowerCase();
  }

  isSpeakerAlreadyInWebinar(speaker: any): boolean {
    const key = this.speakerKey(speaker);
    return this.moderatorsByWebinar.some(
      (m) =>
        (m.email || '').toLowerCase() === key &&
        m.eModerator === this.selectedSpeakerRole?.value,
    );
  }

  isExistingSpeakerSelected(speaker: any): boolean {
    const key = this.speakerKey(speaker);
    return this.selectedExistingSpeakers.some(
      (s) => this.speakerKey(s) === key,
    );
  }

  toggleExistingSpeaker(speaker: any): void {
    if (this.isSpeakerAlreadyInWebinar(speaker)) return;
    const key = this.speakerKey(speaker);
    if (this.isExistingSpeakerSelected(speaker)) {
      this.selectedExistingSpeakers = this.selectedExistingSpeakers.filter(
        (s) => this.speakerKey(s) !== key,
      );
      // Plus personne dans le récapitulatif → retour à la liste
      if (
        this.addSpeakerStep === 'recap' &&
        this.selectedExistingSpeakers.length === 0
      ) {
        this.addSpeakerStep = 'list';
      }
    } else {
      this.selectedExistingSpeakers = [
        ...this.selectedExistingSpeakers,
        speaker,
      ];
    }
  }

  continueWithExistingSpeakers(): void {
    if (this.addSpeakerStep !== 'list') return;
    if (this.selectedExistingSpeakers.length === 0) return;

    // Un seul intervenant : formulaire pré-rempli et modifiable
    if (this.selectedExistingSpeakers.length === 1) {
      const speaker = this.selectedExistingSpeakers[0];
      this.mentorForm.reset();
      this.setCivilityRequired(false);
      this.mentorForm.patchValue({
        civility: speaker.civility || null,
        firstName: speaker.firstName || '',
        lastName: speaker.lastName || '',
        email: speaker.email || '',
        bioModerator: speaker.bioModerator || '',
        role: this.selectedSpeakerRole?.value || '',
      });
      this.mentorForm.updateValueAndValidity();
      this.addSpeakerStep = 'form';
      return;
    }

    // Plusieurs intervenants : récapitulatif
    this.addSpeakerStep = 'recap';
  }

  onSubmitExistingSpeakers(): void {
    if (this.isSubmittingSpeaker) return;
    if (this.selectedExistingSpeakers.length === 0 || !this.selectedSpeakerRole)
      return;
    this.pendingModeratorDto = null;
    this.pendingModeratorDtos = this.selectedExistingSpeakers.map((s) => ({
      civility: s.civility || null,
      firstName: s.firstName,
      lastName: s.lastName,
      email: s.email,
      bioModerator: s.bioModerator || null,
      eModerator: this.selectedSpeakerRole!.value,
    }));
    this.showConfirmModeratorModal = true;
  }

  goBackAddSpeaker(): void {
    switch (this.addSpeakerStep) {
      case 'role':
        this.addSpeakerMode = null;
        this.addSpeakerStep = 'choice';
        break;
      case 'import':
        this.addSpeakerMode = null;
        this.resetImport();
        this.addSpeakerStep = 'choice';
        break;
      case 'list':
        this.addSpeakerStep = 'role';
        break;
      case 'recap':
        this.addSpeakerStep = 'list';
        break;
      case 'form':
        if (this.addSpeakerMode === 'existing') {
          this.addSpeakerStep = 'list';
        } else {
          this.addSpeakerMode = null;
          this.setCivilityRequired(false);
          this.addSpeakerStep = 'choice';
        }
        break;
    }
  }

  getRoleLabel(value: string | null | undefined): string {
    return this.listRole.find((r) => r.value === value)?.name || 'intervenant';
  }

  copyLink(certificat: any): void {
    const link = certificat.urlZoom;

    navigator.clipboard
      .writeText(link)
      .then(() => {
        this.copiedCertificatId = certificat.id;
        setTimeout(() => {
          this.copiedCertificatId = null;
        }, 2000);
      })
      .catch((err) => {
        console.error('Échec de la copie du lien', err);
      });
  }

  duplicateCertificate(certificat: any): void {
    const {
      name,
      shortname,
      fullname,
      displayname,
      urlCertificat,
      plateforme,
      description,
      certifcatCategory,
      category,
      urlImage,
    } = certificat;

    this.router.navigate(['/dashboard/appels/newcertificate'], {
      state: {
        duplicateCertificate: {
          name,
          shortname,
          fullname,
          displayname,
          urlCertificat,
          plateforme,
          description,
          certifcatCategory,
          category,
          urlImage,
          // idcertificat (externalId), id, startdate, enddate, cohorte
          // volontairement exclus : jamais transmis à la duplication
        },
      },
    });
  }

  // Navigation vers la duplication d'un certificat hors parcours
  goToDuplicate(externalId: string) {
    this.router.navigate([
      '/dashboard/appels/hors-sigui-certificate/duplicate',
      externalId,
    ]);
  }
}
